export function findVariableAtCursor(value, cursor) {
    let varStart = value.lastIndexOf('${', cursor);
    if (varStart === -1) return null;
    let varEnd = value.indexOf('}', varStart);
    if (varEnd === -1) return null;
    varEnd += 1;
    if (cursor > varStart && cursor < varEnd) {
        return { varStart, varEnd };
    }
    return null;
}

export function findFileRefAtCursor(value, cursor, fileTrigger) {
    if (!fileTrigger) return null;
    const triggerLen = fileTrigger.length;
    let refStart = value.lastIndexOf(fileTrigger, cursor);
    if (refStart === -1) return null;
    if (refStart + triggerLen < value.length && value[refStart + triggerLen] !== '[') return null;
    const bracketStart = refStart + triggerLen;
    const bracketEnd = value.indexOf(']', bracketStart);
    if (bracketEnd === -1) return null;
    const refEnd = bracketEnd + 1;
    if (cursor > refStart && cursor < refEnd) {
        return { varStart: refStart, varEnd: refEnd };
    }
    return null;
}

export function findFileSegmentInDisplay(displayStr, cursor, fileSuggestions) {
    if (!fileSuggestions.length) return null;
    for (const f of fileSuggestions) {
        if (!f.name) continue;
        let idx = 0;
        while (idx < displayStr.length) {
            const start = displayStr.indexOf(f.name, idx);
            if (start === -1) break;
            const end = start + f.name.length;
            if (cursor >= start && cursor <= end) {
                return { varStart: start, varEnd: end };
            }
            idx = end;
        }
    }
    return null;
}

export function calculateDropdownPosition(input) {
    if (!input) return { top: 0, left: 0 };

    const inputRect = input.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const dropdownWidth = window.innerWidth >= 1440 ? 450 : 400;
    const dropdownHeight = window.innerWidth >= 1440 ? 220 : 200;
    const spacing = window.innerWidth >= 1440 ? 6 : 4;

    let top = inputRect.bottom + spacing;
    let left = inputRect.left;

    if (left + dropdownWidth > viewportWidth - 20) {
        left = viewportWidth - dropdownWidth - 20;
    }
    if (left < 20) left = 20;

    if (top + dropdownHeight > viewportHeight - 20) {
        top = inputRect.top - dropdownHeight - spacing;
        if (top < 20) top = 20;
    }

    return { top, left };
}

export function getDropdownState({
    val,
    cursor,
    readOnly,
    disabled,
    variableTrigger,
    fileTrigger,
    suggestionsLength,
    fileSuggestionsLength,
}) {
    if (readOnly || disabled) return { show: false, mode: null };
    if (variableTrigger && cursor >= variableTrigger.length) {
        const slice = val.slice(cursor - variableTrigger.length, cursor);
        if (slice === variableTrigger && suggestionsLength > 0) {
            return { show: true, mode: 'variables' };
        }
    }
    if (fileTrigger && cursor >= fileTrigger.length) {
        const slice = val.slice(cursor - fileTrigger.length, cursor);
        if (slice === fileTrigger && fileSuggestionsLength > 0) {
            return { show: true, mode: 'files' };
        }
    }
    return { show: false, mode: null };
}
